import {isRTL} from '../../../../Localization';

const en = {
    actionPlaceholder: 'Search for Action...',
    actionsBtnLabel: 'Actions'
};

const he = {
    actionPlaceholder: 'חיפוש פעולה',
    actionsBtnLabel: 'פעולות'
};

export const texts = isRTL() ? he : en;
